import React from 'react';
import './PromotionPopup.less';

interface IPromotionPopupPropType {
    prefixCls?: string;
    onCloseBox?: () => void;
    msg?: string;
}

/**
 * 促销活动购买件数提示框
 * @class PromotionPopup
 * @extends {React.Component}
 */
class PromotionPopup extends React.Component<IPromotionPopupPropType, any> {
    static defaultProps = {
        prefixCls: 'promotion-popup'
    };

    render() {
        const {prefixCls, onCloseBox, msg} = this.props;
        return (
            <div>
                <div className={`${prefixCls}-cover`} onClick={onCloseBox}/>
                <div className={`${prefixCls}-container`}>
                    <div className={`${prefixCls}-context`}>
                        <p>{msg}</p>
                    </div>
                    <div className={`${prefixCls}-btn`} onClick={onCloseBox}>确定</div>
                </div>
            </div>
        );
    }
}

export default PromotionPopup;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/promotionPopup/PromotionPopup.tsx